import React, { useState, useEffect } from "react";
import { Modal, TextInput, Button, Grid, Alert } from "@mantine/core";
import { IconSend, IconAlertCircle } from "@tabler/icons";
import { showNotification } from "@mantine/notifications";
import { apiWithInterceptor } from "../../../../api";

const SendSmsModal = ({ opened, setOpenSms, sessionId }) => {
  const [smsMessageValue, setSmsMessageValue] = useState("");
  const maxCharacterCount = 55; // Set the maximum character count as needed
  const characterCount = smsMessageValue?.length;

  useEffect(() => {
    if (localStorage.getItem("sms_template") === null) {
      setSmsMessageValue("");
    } else {
      setSmsMessageValue(
        JSON.parse(localStorage.getItem("sms_template")).message
      );
    }
  }, [opened]);

  return (
    <Modal
      opened={opened}
      onClose={() => {
        setOpenSms(false);
      }}
      title="Send sms to all tickets"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          apiWithInterceptor
            .post("/ticket/send-sms-to-tickets", {
              message: smsMessageValue,
              session_id: sessionId,
            })
            .then((res) => {
              console.log(res);
              setOpenSms(false);
              showNotification({
                title: "Success",
                message: "SMS Successfully Sent",
                color: "green",
              });

              localStorage.setItem(
                "sms_template",
                JSON.stringify({
                  message: smsMessageValue,
                })
              );
            })
            .catch((err) => {
              console.log(err);
              showNotification({
                title: "Failed",
                message: "Something went wrong :(",
                color: "red",
              });
            });
        }}
      >
        <Grid>
          <Grid.Col>
            <TextInput
              variant="filled"
              label="SMS message"
              placeholder="Enter no more than 55 letter SMS message..."
              error={
                characterCount > maxCharacterCount
                  ? "Too many characters this will cost much more credit to send"
                  : null
              }
              value={smsMessageValue}
              onChange={(e) => {
                setSmsMessageValue(e.target.value);
              }}
              rightSection={
                <span
                  style={{
                    color: "lightgray",
                    fontSize: "12px",
                    marginRight: "0px",
                  }}
                >
                  {characterCount}/{maxCharacterCount}
                </span>
              }
            />
          </Grid.Col>
          <Grid.Col>
            <Alert
              icon={<IconAlertCircle size={16} />}
              title="Warning"
              color="red"
            >
              Make sure the message is as you want and ok because once you click
              send you can't cancel !!
              <br />
              <span style={{ fontWeight: "700", color: "red" }}>
                IT WILL BE SENT TO ALL TICKETS.
              </span>
            </Alert>
          </Grid.Col>

          <Grid.Col>
            <Button
              type="submit"
              variant="filled"
              rightIcon={<IconSend size={15} />}
            >
              Send
            </Button>
          </Grid.Col>
        </Grid>
      </form>
    </Modal>
  );
};

export default SendSmsModal;
